<template>
  <v-container p-0>
    <v-row class="my-0">
      <v-col class="pt-0 pb-0 my-0" cols="12">
        <div class="subtitle-1">{{ $t('LoggedArea.Data.DataTitle') }}</div>
      </v-col>
    </v-row>

    <v-card class="mx-auto mt-2" max-width="350">
      <v-card-text>
        <div>{{ $t('LoggedArea.Data.GraphData.ProfileViewData')}}</div>
        <v-img class="mt-2">
          <bar-chart v-if="loaded" :chartdata="chartData" :options="chartOptions"></bar-chart>
          <!-- condition that shows only if there is no data to show for the profile--> 
          <div v-else>{{ $t('LoggedArea.Data.GraphData.NoDataAlert')}}</div>
        </v-img>
      </v-card-text>
    </v-card>
    <!-- Separação para dados dos Cards -->  

  </v-container>
</template>

<script>
import barChart from "./barChart";
import { db } from "@/config/firebaseConfig";

export default {
  components: {
    barChart,
  },
  data() {
    return {
      loaded: false,
      snapshot: null, 
      chartData: {
        labels: null,
        datasets: null,
      },
      chartOptions: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  },
  methods:{
    getdataProfile() {
      let dataArrLabel = [];
      let dataChildValue = [];
  
      const uid = this.$store.state.user.userID;
      var datatotal = db.ref(`/analytics/${uid}/pageview/`);
      datatotal.once("value").then(snapshot => {      
          snapshot.forEach(childsnapshot => {
            dataArrLabel.push(childsnapshot.key);
            dataChildValue.push(childsnapshot.val());
          })
        }).then(()=> {
          this.chartData.labels = dataArrLabel;
          //condition to show an alert when there is no data on the profile
          if (dataArrLabel.length==0){
            this.loaded=false;
          } else {
          let data
          data = dataChildValue.map(obj => Object.values(obj).reduce((a,b) => a + b ));
          this.chartData.datasets = 
           [{
             backgroundColor: "#4a148c",
             data,
          }];
          this.loaded = true;
          }
        })
    },
  },
  async mounted() {
    this.loaded = false
    await this.getdataProfile();
    //await this.getdataLinks();
  },
};
</script>

<style>
</style>